/** Canonical API paths — keep in sync with backend (sia-app-fe contract). */

export const AUTH_LOGIN = '/api/auth/login'
export const AUTH_REGISTER = '/api/auth/register'
export const AUTH_REFRESH = '/api/auth/refresh'
export const AUTH_LOGOUT = '/api/auth/logout'

export const WHOAMI = '/api/auth/me'

export const TOOLKIT_CATALOG = '/api/toolkit/catalog'

export const CHAT_COMPLETIONS = '/api/chat/completions'
export const CHAT_THREADS = '/api/threads'

export const APPGEN = '/api/appgen'

export const MEETING_NOTES = '/api/meeting-notes'
export const MEETING_NOTES_QUERY = '/api/meeting-notes/query'
export const MEETING_NOTES_TRANSCRIPT = '/api/meeting-notes/transcript'
